import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export interface SymbolData {
  // ticker: string;
  usdt: string;
}

export interface TickerState {
  symbols: Record<string, SymbolData>;
  setSymbolData: (symbol: string, data: Partial<SymbolData>) => void;
  getSymbolData: (symbol: string) => SymbolData | undefined;
  addSymbol: (symbol: string, initialData?: Partial<SymbolData>) => void;
  removeSymbol: (symbol: string) => void;
}

// ... existing code ...

export const useTickerStore = create<TickerState>()(
  persist(
    (set, get) => ({
      symbols: {
        // sfl: {
        //   // ticker: '',
        //   krw: '',
        //   usdt: '',
        // },
        // tri: {
        //   ticker: '',
        //   krw: '',
        //   usdt: '',
        // },
      },

      setSymbolData: (symbol, data) => {
        set((state) => ({
          symbols: {
            ...state.symbols,
            [symbol]: {
              ...state.symbols[symbol],
              ...data,
            },
          },
        }));
      },

      getSymbolData: (symbol) => {
        return get().symbols[symbol];
      },

      addSymbol: (symbol, initialData = {}) => {
        set((state) => ({
          symbols: {
            ...state.symbols,
            [symbol]: {
              // ticker: '',
              usdt: '',
              ...initialData,
            },
          },
        }));
      },

      removeSymbol: (symbol) => {
        set((state) => {
          const newSymbols = { ...state.symbols };
          delete newSymbols[symbol];
          return { symbols: newSymbols };
        });
      },
    }),
    {
      name: 'ticker-storage',
      partialize: (state) => ({
        symbols: state.symbols,
      }),
    },
  ),
);